import { useContext } from "react";
import type { Attributes } from "@splitsoftware/splitio/types/splitio";
import { SplitContext, useTreatments } from "@splitsoftware/splitio-react";

import { getE2eSplitFeatureFlagOverride } from "@/utils/e2e/getE2ESplitFeatureFlagOverrides";

import type { FeatureFlagName } from "../constants";
import { getTreatmentConfig } from "../utils";

export type FeatureFlagResult = {
  config: Record<string, unknown>;
  isOn: boolean;
  isReady: boolean;
};

export function useFeatureFlag(
  name: FeatureFlagName,
  attributes: Attributes = {},
): FeatureFlagResult {
  const { isReady } = useContext(SplitContext);
  const result = useTreatments([name], attributes)[name];

  const config = getTreatmentConfig(result.config);
  const isOn = result.treatment === "on";

  const e2eFeatureFlagOverride = getE2eSplitFeatureFlagOverride(name);

  if (e2eFeatureFlagOverride) {
    return e2eFeatureFlagOverride;
  }

  return { isOn, isReady, config };
}
